import { Card } from 'react-bootstrap'

const ToolboxItem = (props) => {
    const { toolboxItem, onDragStart } = props
    const { type } = toolboxItem
    return (
        <Card
            draggable={true}
            className="w-100 p-3 mb-2"
            key={type}
            onDragStart={onDragStart}
        >
            {type.label}
        </Card>
    )
}

export default ToolboxItem
